export default __webpack_public_path__ + "static/media/noah_logo.dec36934.png";